import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

type VimeoType = {
    id: number;
    isSound: boolean;
};

const vimeoAtom = atom<VimeoType>({
    default: {
        id: 0,
        isSound: false,
    },
    key: ATOM_KEY.VIMEO_DATA,
});

export const useVimeoState = () => useRecoilState(vimeoAtom);
export const useSetVimeoState = () => useSetRecoilState(vimeoAtom);
export const useVimeoValue = () => useRecoilValue(vimeoAtom);
